import "./polyfills";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { SolanaProvider } from "./providers/SolanaProvider";
import { applyMobileWalletFix } from "./lib/mobileWalletFix";
import { setupPhantomMonitor, checkDomainTrust, exportDiagnosticReport } from "./lib/phantomWarningMonitor";

// Applica fix per wallet mobile
applyMobileWalletFix();

// Setup Phantom warning monitor for debugging
if (typeof window !== 'undefined') {
  const cleanupPhantomMonitor = setupPhantomMonitor();
  
  // Log domain trust score on load
  window.addEventListener('load', () => {
    const trust = checkDomainTrust();
    if (trust.issues.length > 0) {
      console.warn('[Phantom Trust] Issues detected:', trust.issues);
    }
    console.log('[Phantom Trust] Score:', trust.score);
  });
  
  // Expose diagnostic function for dev debugging
  (window as any).__phantomDiagnostics = exportDiagnosticReport;
}

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <SolanaProvider>
      <App />
    </SolanaProvider>
  </React.StrictMode>
);
